import restaurantAdminInstance from '../../../adminInstance'

const updateTableCartForAdmin = (tableId, data, accessToken) => {
	return restaurantAdminInstance.post(`/tables/${tableId}/orders/updateCart`, data, {
		headers: {
			'Authorization': `Bearer ${accessToken}`,
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
		},
	})
}

export default updateTableCartForAdmin
